export type SubscriptionStatus =
  | 'trialing'
  | 'active'
  | 'past_due'
  | 'canceled'
  | 'unpaid';

export type PlanTier = 'trial' | 'starter' | 'growth' | 'scale';

export interface Subscription {
  id: string;
  user_id: string;
  stripe_customer_id: string;
  stripe_subscription_id: string | null;
  plan_tier: PlanTier;
  status: SubscriptionStatus;
  current_period_start: string;
  current_period_end: string;
  cancel_at_period_end: boolean;
  trial_ends_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface PlanConfig {
  tier: PlanTier;
  name: string;
  leads_per_day: number;
  price_monthly: number;
  price_yearly: number;
  features: string[];
}

export const PLAN_CONFIGS: Record<PlanTier, PlanConfig> = {
  trial: {
    tier: 'trial',
    name: 'Free Trial',
    leads_per_day: 3,
    price_monthly: 0,
    price_yearly: 0,
    features: [
      '3 leads per day',
      'AI email drafting',
      'Gmail integration',
      '14-day trial',
    ],
  },
  starter: {
    tier: 'starter',
    name: 'Starter',
    leads_per_day: 3,
    price_monthly: 49,
    price_yearly: 470,
    features: [
      '3 leads per day',
      'AI email drafting',
      'Gmail integration',
      'Reply detection',
      'Email support',
    ],
  },
  growth: {
    tier: 'growth',
    name: 'Growth',
    leads_per_day: 5,
    price_monthly: 99,
    price_yearly: 950,
    features: [
      '5 leads per day',
      'AI email drafting',
      'Gmail integration',
      'Reply detection',
      'Priority alerts',
      'Priority support',
    ],
  },
  scale: {
    tier: 'scale',
    name: 'Scale',
    leads_per_day: 10,
    price_monthly: 199,
    price_yearly: 1910,
    features: [
      '10 leads per day',
      'AI email drafting',
      'Gmail integration',
      'Reply detection',
      'Priority alerts',
      'Dedicated support',
      'Custom integrations',
    ],
  },
};
